import { render, staticRenderFns } from "./documentModelAdd.vue?vue&type=template&id=5e061b72&scoped=true&"
import script from "./documentModelAdd.vue?vue&type=script&lang=js&"
export * from "./documentModelAdd.vue?vue&type=script&lang=js&"
import style0 from "./documentModelAdd.vue?vue&type=style&index=0&id=5e061b72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e061b72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e061b72')) {
      api.createRecord('5e061b72', component.options)
    } else {
      api.reload('5e061b72', component.options)
    }
    module.hot.accept("./documentModelAdd.vue?vue&type=template&id=5e061b72&scoped=true&", function () {
      api.rerender('5e061b72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/manage/components/documentModelAdd.vue"
export default component.exports